import {loadSummaryMonths} from "../../api/forecasts/summary-monthly.api";
import {loadForecasts} from "../../api/forecasts/forecasts.api";
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  summaryMonths: [],
  dailyForecast: [],
  hourlyForecast: [],
};
const mutations = {
  setSummaryMonths(state, data){
    state.summaryMonths = data ? data :  [];
  },
  setDailyForecast(state, data){
    state.dailyForecast = data ? data :  [];
  },
  setHourlyForecast(state, data){
    state.hourlyForecast = data ? data :  [];
  },
};

const actions = {
  async loadSummaryMonths( {commit}, payload ){
    try{
      const response = await loadSummaryMonths({...payload});
      commit('setSummaryMonths', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos sumários mensais.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setSummaryMonths', undefined)
    }
  },
  async loadDailyForecast( {commit}, payload ){
    try{
      const response = await loadForecasts({...payload});
      commit('setDailyForecast', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das previsões diárias.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setDailyForecast', undefined)
    }
  },
  async loadHourlyForecast( {commit}, payload ){
    try{
      const response = await loadForecasts({...payload});
      commit('setHourlyForecast', response.data)
    }catch(error){
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das previsões horárias.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setHourlyForecast', undefined)
    }
  },

};

const getters = {
  summaryMonths: (state) => state.summaryMonths,
  dailyForecast: (state) => state.dailyForecast,
  hourlyForecast: (state) => state.hourlyForecast,
};
export default {
  state,
  mutations,
  actions,
  getters
}
